export default "<ng-content></ng-content>\n<ok-stamp></ok-stamp>\n";